import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  style: {"z-index":"1002"},
  class: "flex items-center bg-dark fixed top-0 left-0 w-full h-14 shadow-elevation bg-opacity-90 px-2"
}
const _hoisted_2 = { class: "mr-auto" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined text-lightText" }, "close", -1)
const _hoisted_4 = { class: "text-lightText flex items-center space-x-4" }
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "ml-auto" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined text-lightText" }, "file_download", -1)
const _hoisted_8 = {
  style: {"z-index":"1001"},
  class: "mt-14 fixed top-1/2 transform -translate-y-1/2 -translate-x-1/2 left-1/2 overflow-y-auto h-screen w-max flex"
}
const _hoisted_9 = { class: "m-auto flex flex-col items-center" }
const _hoisted_10 = { class: "-mt-40 text-lightText" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Btn = _resolveComponent("Btn")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _directive_wave = _resolveDirective("wave")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "fixed h-screen w-screen top-0 left-0 bg-dark bg-opacity-60",
      style: {"z-index":"1000"},
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('viewerClose')))
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Btn, {
          class: "mr-2",
          variant: 'icon',
          outline: true,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('viewerClose')))
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h3", _hoisted_5, _toDisplayString(_ctx.filename), 1)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_Btn, {
          class: "mr-2",
          loading: _ctx.downloading,
          variant: 'icon',
          outline: true,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('download')))
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("h1", _hoisted_10, _toDisplayString(_ctx.$t("misc.download")) + " " + _toDisplayString(_ctx.filename), 1),
        _createVNode(_component_Tooltip, {
          placement: 'bottom',
          noArrow: true,
          textValue: _ctx.$t('misc.download')
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("span", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('download'))),
              style: {"font-size":"10rem !important"},
              class: "mb-1 filter drop-shadow-lg cursor-pointer opacity-70 rounded-full material-icons-outlined text-lightText hover:opacity-90 transition-opacity duration-100 ease-in-out p-4"
            }, [
              _createTextVNode("cloud_download")
            ])), [
              [_directive_wave]
            ])
          ]),
          _: 1
        }, 8, ["textValue"])
      ])
    ])
  ], 64))
}